import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// httpOnly cookie 'access_token' is set on login/logout and sent automatically
// with withCredentials. We do NOT store tokens in localStorage (XSS risk).
const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// ── Tenant impersonation header ─────────────────────────────────────────────
// Platform-superadmins kunnen tijdelijk als een andere organisatie kijken door
// een org_id in sessionStorage te zetten (via de PlatformAdminBar switcher).
// De backend accepteert `X-Impersonate-Org` alleen als de user zelf platform-
// super is; voor iedereen anders wordt de header genegeerd (fail-closed).
const IMPERSONATE_KEY = "webster:impersonate_org";

export function getImpersonatedOrg() {
  try { return sessionStorage.getItem(IMPERSONATE_KEY) || null; }
  catch { return null; }
}

export function setImpersonatedOrg(orgId) {
  try {
    if (orgId) sessionStorage.setItem(IMPERSONATE_KEY, orgId);
    else sessionStorage.removeItem(IMPERSONATE_KEY);
  } catch { /* privacy-mode → nooit crashen */ }
}

api.interceptors.request.use((config) => {
  const org = getImpersonatedOrg();
  if (org) {
    config.headers = config.headers || {};
    config.headers["X-Impersonate-Org"] = org;
  }
  return config;
});

export default api;

export function formatApiError(detail) {
  if (detail == null) return "Er is iets misgegaan. Probeer het opnieuw.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
